// «Соблюдение скрипта по шагам» — какие шаги скрипта не выполняются и из-за
// каких критериев (#879). Вход — из виджета «Пропущенные шаги» вкладки Quality;
// фильтр виджета (период, проекты) приходит параметрами адреса.
import { useCallback } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { ListChecks } from 'lucide-react';
import { DashboardBody } from '@/components/layout/DashboardBody';
import { Breadcrumb, BreadcrumbItem } from '@/components/navigation/breadcrumb';
import { useDocumentTitle } from '@/hooks/useDocumentTitle';
import { ScriptStepsView } from '@/components/analytics/script-steps/ScriptStepsView';
import {
  parseScriptStepsSearch,
  type ScriptStepsSearch,
} from '@/components/analytics/script-steps/script-steps-search';

function ScriptStepsPage() {
  const { t } = useTranslation('dashboard');
  useDocumentTitle(t('scriptStepsPage.title'));
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  const onSearchChange = useCallback(
    (patch: Partial<ScriptStepsSearch>) =>
      void navigate({ search: (previous) => ({ ...previous, ...patch }), replace: true }),
    [navigate]
  );

  return (
    <DashboardBody
      title={t('scriptStepsPage.title')}
      subtitle={t('scriptStepsPage.subtitle')}
      icon={ListChecks}
      breadcrumbs={
        <Breadcrumb>
          <BreadcrumbItem href="/">Aelo</BreadcrumbItem>
          <BreadcrumbItem href="/dashboard">
            {t('scriptStepsPage.breadcrumbParent')}
          </BreadcrumbItem>
          <BreadcrumbItem current>{t('scriptStepsPage.title')}</BreadcrumbItem>
        </Breadcrumb>
      }
    >
      <ScriptStepsView search={search} onSearchChange={onSearchChange} />
    </DashboardBody>
  );
}

export const Route = createFileRoute('/analytics/script-steps')({
  component: ScriptStepsPage,
  validateSearch: (search: Record<string, unknown>): ScriptStepsSearch =>
    parseScriptStepsSearch(search),
});
